<mat-form-field
  [appearance]="$any(appearance)"
  [floatLabel]="$any(floatLabel)"
  [ngClass]="fieldClass"
>
  <mat-label *ngIf="label">{{ label | translate }}</mat-label>
  <input
    *ngIf="control"
    matInput
    [type]="inputType"
    [id]="inputId || null"
    [attr.data-testid]="testId || null"
    [formControl]="control"
    [autocomplete]="autocomplete"
    [placeholder]="placeholder ? (placeholder | translate) : ''"
    [readonly]="readonly"
    (blur)="blurEvent.emit($event)"
    (keyup)="keyupEvent.emit($event)"
  />
  <input
    *ngIf="!control"
    matInput
    [type]="inputType"
    [id]="inputId || null"
    [attr.data-testid]="testId || null"
    [value]="value"
    disabled
  />
  <button
    *ngIf="passwordToggle"
    type="button"
    mat-icon-button
    matSuffix
    (click)="hide = !hide"
    [ngClass]="suffixClass"
    [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
    [attr.aria-pressed]="hide"
  >
    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
  <mat-hint *ngIf="hint">{{ hint | translate }}</mat-hint>
  <!-- Single top-level mat-error: selector-based projection only matches
       top-level content nodes, so mat-errors nested in an *ngFor ng-container
       would miss the subscript slot and render inside the field, always. -->
  <mat-error *ngIf="activeErrorKey">
    {{ errors[activeErrorKey] | translate: errorParams(activeErrorKey)
    }}{{ errorSuffix }}
  </mat-error>
</mat-form-field>
